import type { AnalyticsItemsEvent } from '.';

declare global {
   interface Window {
      TriplePixel?: {
         (event: string, params: Record<string, unknown>): void;
      };
   }
}

export function trackTripleWhaleAddToCart(event: AnalyticsItemsEvent) {
   if (typeof window === 'undefined' || window.TriplePixel === undefined) {
      return;
   }
   for (const item of event.items) {
      window.TriplePixel('AddToCart', {
         item: item.numericProductId,
         q: item.quantity,
         v: item.item_variant,
         token: event.shopifyCartId,
      });
   }
}
